import { render, staticRenderFns } from "./MyOrdersPage.vue?vue&type=template&id=f156818c&scoped=true"
import script from "./MyOrdersPage.vue?vue&type=script&lang=js"
export * from "./MyOrdersPage.vue?vue&type=script&lang=js"
import style0 from "./MyOrdersPage.vue?vue&type=style&index=0&id=f156818c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f156818c",
  null
  
)

export default component.exports